import { render, staticRenderFns } from "./ValueCountTags.vue?vue&type=template&id=26c6f48d&scoped=true&"
import script from "./ValueCountTags.vue?vue&type=script&lang=js&"
export * from "./ValueCountTags.vue?vue&type=script&lang=js&"
import style0 from "./ValueCountTags.vue?vue&type=style&index=0&id=26c6f48d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c6f48d",
  null
  
)

export default component.exports